// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  // Icon,
  // Dialog,
  // DialogContent,
  // DialogContentText,
  // DialogTitle,
  // DialogActions,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
// import MDButton from "theme/components/MDButton";
// import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import DataTable from "theme/Tables/DataTable";
import usePageTitle from "app/pageTitle";
import AppConfig from "appConfig";

function TeamPerformance() {
  const pageTitle = "Team Performance";
  usePageTitle(pageTitle);

  const { id: reference } = useParams();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [teamName, setTeamName] = useState(null);
  const [members, setMembers] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState(null);

  const tableTeamMembersColumns = [
    { Header: "Agent", accessor: "agent", align: "left" },
    { Header: "Sales", accessor: "sales", align: "center" },
    // { Header: "Volumn", accessor: "volumn", align: "center" },
  ];

  const buildPerformanceRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        agent: row.agent,
        sales: row.sales,
        // volumn: row.volumn,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      const campaign = selectedCampaign !== null ? selectedCampaign : "ALL";
      await axios
        .get(`agents/teams/performance/${reference}/${campaign}`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setTeamName(result.data.data.title);
            setCampaigns(result.data.data.campaigns);
            const rowsMembers = buildPerformanceRows(result.data.data.members);
            setMembers(rowsMembers);

            setSelectedCampaign(null);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [selectedCampaign]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox pt={3} pb={3}>
        <Card sx={{ width: "100%", marginTop: "15px" }}>
          <MDBox p={3}>
            <MDTypography variant="caption" fontWeight="light" textTransform="capitalize">
              Team Performance
            </MDTypography>
            <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
              {teamName}
            </MDTypography>
          </MDBox>
        </Card>
      </MDBox>

      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={1} pt={4}>
                      <MDBox ml={2} mr={3} mb={3}>
                        <Grid container spacing={3}>
                          <Grid item xs={12} md={4} lg={4}>
                            <MDBox align="right">
                              <FormControl sx={{ minWidth: 180, width: "100%" }}>
                                <InputLabel>Filter By Campaign</InputLabel>
                                <Select
                                  label="Filter By Campaign"
                                  onChange={(e) => {
                                    setSelectedCampaign(e.target.value);
                                  }}
                                  sx={{ padding: "12px", paddingLeft: "3px" }}
                                >
                                  {
                                    // --> Notice below changes
                                    campaigns.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                      campaigns.map((record) => (
                                        <MenuItem value={record.reference}>
                                          <img
                                            src={`${AppConfig.api_media_url}${record.account.icon}`}
                                            alt=""
                                            width="14px"
                                          />
                                          &nbsp;{record.account.name} | {record.title}
                                        </MenuItem>
                                      ))
                                  }
                                </Select>
                              </FormControl>
                            </MDBox>
                          </Grid>
                        </Grid>
                      </MDBox>
                      <MDBox mt={3}>
                        <DataTable
                          table={{ columns: tableTeamMembersColumns, rows: members }}
                          isSorted
                          search={false}
                          entriesPerPage={false}
                          showTotalEntries
                          noEndBorder
                        />
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default TeamPerformance;
